import { MutationConfig, useMutation } from "react-query";
import { IError } from "api/types";
import { snoozeRiskProfileReminder } from "./request";
import { ISnoozeRiskProfileReminderResponse } from "./types";

export const useSnoozeRiskProfileReminder = (
	options?: MutationConfig<ISnoozeRiskProfileReminderResponse, IError, void>,
) => {
	return useMutation<ISnoozeRiskProfileReminderResponse, IError, void>(
		snoozeRiskProfileReminder,
		options,
	);
};
